"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__a",
    x1: "7.821%",
    x2: "90.816%",
    y1: "91.246%",
    y2: "9.417%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFAA1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.324%",
    stopColor: "#DA012C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C0009B"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.865,
    height: 23.865,
    x: 0.097,
    fill: "url(#instagram_svg__a)",
    rx: 11.933
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.806 4.806)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.563,
    height: 12.615,
    x: 0.934,
    y: 0.945,
    stroke: "#FFF",
    rx: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.141,
    cy: 7.153,
    r: 3.106,
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.975,
    cy: 3.369,
    r: 1,
    fill: "#FFF"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgInstagram);
var _default = exports["default"] = Memo;